<p-toast></p-toast>

<div class="grid mx-3">
  <div class="col-12">
    <p-table [value]="flags"
            dataKey="id"
            styleClass="datatable-sm"
            [scrollable]="true"
            scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Donation Flag</th>
          <th>Description</th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-donorFlagItem>
        <tr>
          <td>{{ donorFlagItem.name }}</td>
          <td>{{ donorFlagItem.description }}</td>
          <td>
            <!--<rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" data-cy="btn-edit"
                              (clickHandler)="onEditFlag(donorFlagItem)" />-->
            <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-delete"
                              [classes]="['table-action-btn']" (clickHandler)="onDeleteFlag(donorFlagItem)" [disabled]="isReadOnlyMode" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" *ngIf="flags.length==0">
        <tr>
          <td style="text-align: center;" colspan="2">
            There are no donation flags found for this donation
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="flex justify-content-end mt-2">
      <rc-generic-button label="Add New Flag" iconImg="plus" borderStyle="text-only" level="secondary" size="small" (click)="onAddFlag()" [disabled]="isReadOnlyMode" />
    </div>
  </div>
</div>

<!-- MODAL -->
<p-dialog 
  header="{{ isEditMode ? 'Edit Donation Flag' : 'Add New Donation Flag' }}" 
  [(visible)]="showAddEditDialog" 
  [modal]="true" 
  draggable="false" 
  styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300">
  <form [formGroup]="donationFlagFormGroup">
    <div class="formgrid grid">

      <div class="field col-12 mb-5">
        <label class="field-label mb-3" for="isAddMode">Mode</label>
        <div class="flex align-items-center gap-2">
          <p-inputSwitch formControlName="isAddMode" (click)="toggleMode()"></p-inputSwitch>
          <label class="font-normal mb-0" for="isAddMode">{{ isAddMode ? 'Create New Flag' : 'Add Existing Flag' }}</label>
        </div>
      </div>

      <div class="field col-12" *ngIf="!isAddMode">
        <label for="searchFlag" class="field-label required">Search Existing Flags</label>
        <p-autoComplete 
          id="searchFlag" 
          formControlName="selectedFlag" 
          [suggestions]="filteredFlags" 
          (completeMethod)="searchFlags($event)"
           optionLabel="name"
           optionValue="id"
           placeholder="Type to Search">
        </p-autoComplete>
      </div>

      <div class="field col-12" *ngIf="isAddMode">
        <div class="field">
          <label for="name" class="required">Flag Name</label>
          <input id="name" type="text" pInputText formControlName="name" [ngClass]="{'ng-invalid': donationFlagFormGroup.controls['name'].invalid && donationFlagFormGroup.controls['name'].touched}" />
          <small class="p-error" *ngIf="donationFlagFormGroup.controls['name'].invalid && donationFlagFormGroup.controls['name'].touched">
            Flag Name is required.
          </small>
        </div>
        <div class="field">
          <label for="description" class="required">Description</label>
          <textarea id="description" pInputTextarea formControlName="description" [ngClass]="{'ng-invalid': donationFlagFormGroup.controls['description'].invalid && donationFlagFormGroup.controls['description'].touched}"></textarea>
          <small class="p-error" *ngIf="donationFlagFormGroup.controls['description'].invalid && donationFlagFormGroup.controls['description'].touched">
            Description is required.
          </small>
        </div>
      </div>
    </div>
    <div class="imported-dialog-footer">
      <p-button 
        label="Cancel" 
        type="button" 
        [text]="true" 
        (click)="closeAddEditDialog()">
      </p-button>
      <p-button 
        label="Save" 
        severity="primary" 
        type="button" 
        [disabled]="isAddMode ? donationFlagFormGroup.invalid : !donationFlagFormGroup.get('selectedFlag')?.value || isReadOnlyMode" 
        (click)="saveFlag()">
      </p-button>
    </div>
  </form>
</p-dialog>

<p-dialog header="Confirm Action" 
  [(visible)]="showDeleteDialog" 
  [modal]="true" 
  [closable]="false"
  styleClass="p-confirm-dialog">

  <p>Are you sure you want to delete this flag?</p>
  
  <p-footer>
    <button pButton type="button" label="Cancel" (click)="closeDeleteDialog()"></button>
    <button pButton type="button" label="Delete" (click)="confirmDeleteFlag()" [disabled]="isReadOnlyMode"></button>
  </p-footer>
</p-dialog>
